module.exports = __webpack_public_path__ + "img/ico-chest-gold.9a75d936.png";